(function (angular) {
  "use strict";

  filterMembers.$inject = ["industries", "thisSiteSettings"];

  function filterMembers(industries, thisSiteSettings) {
    function link($scope) {
      industries.unshift("-- All --");
      $scope.industries = industries;
      $scope.userAttrsConfig = thisSiteSettings.user_attrs;
      $scope.siteUserDefinition = thisSiteSettings.site_user_definition;

      $scope.distanceSliderOptions = {
        stepsArray: getDistanceSliderSteps(),
        showTicks: false,
        translate: function (step) {
          if (step === 20000) {
            return "Any Distance";
          }
          return step + " miles";
        },
      };

      /**
       * Builds an array of steps for the distance slider control
       * @return {array}
       */
      function getDistanceSliderSteps() {
        var steps = [],
          i = 1;

        for (i; i < 50; i++) {
          steps.push(i);
        }

        steps.push(20000);

        return steps;
      }
    }

    return {
      link: link,
      restrict: "E",
      scope: {
        members: "=",
        filters: "=",
        getMembers: "&",
        resetMembers: "&",
      },
      templateUrl: "directives/filter-members.html",
    };
  }

  angular.module("app").directive("filterMembers", filterMembers);
})(angular);
